import { api_GET } from "./_api.js";

const variaveisSistema_api = {
    getList: (tipo = "") => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`VariaveisSistema/GetList/${tipo}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default variaveisSistema_api;
